module.exports = __webpack_public_path__ + "img/6569e48.svg";